import SourcesList from './SourcesList';

export default SourcesList;
